import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import {
  Button,
  IconButton,
  Tooltip,
  DialogContent,
  Dialog,
  DialogActions,
  DialogTitle,
  TextField,
} from "@mui/material";
import { toast } from "react-toastify";
import moment from "moment";
import { Close } from "@mui/icons-material";
import Axios from "../axios";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { CSVLink } from "react-csv";
import "react-quill/dist/quill.snow.css";
import { Helmet } from "react-helmet";
import DownloadIcon from "@mui/icons-material/Download";

const BookingList = () => {
  const [open, setOpen] = useState(false);
  const [arrivalList, setArrivalList] = useState();
  const [page, setPage] = useState(0);
  const [count, setCount] = useState();
  const [search, setSearch] = useState("");
  const [openDialog, setOpenDialog] = useState({ status: false, id: "" });
  const [remarks, setRemarks] = useState("");
  const [viewData, setViewData] = useState();
  const [downloadData, setDownloadData] = useState([]);

  const headers = [
    { label: "Booking ID", key: "bookingID" },
    { label: "Booking Date", key: "bookingDate" },
    { label: "Check in date", key: "tripStartDate" },
    { label: "Checkout date", key: "tripEndDate" },
    { label: "Customer email", key: "email" },
    { label: "Guest Name", key: "guestNames" },
    { label: "Room Count", key: "roomsCount" },
    { label: "Nights", key: "nights" },
    { label: "Room Nights", key: "nights" },
    { label: "Room type booked", key: "rooms" },
    { label: "Value adds included", key: "valueAddedService" },
    { label: "Sell Rate(USD)", key: "sellRate" },
    { label: "Net Rate(USD)", key: "netRate" },
    { label: "Hotel Confirmation", key: "hotelConfirmation" },
    { label: "Supplier Property ID", key: "supplierPropertyID" },
    { label: "Property ID", key: "propertyID" },
    { label: "Property Name", key: "propertyName" },
    { label: "Property Address", key: "propertyAddress" },
    { label: "Property Region", key: "propertyRegion" },
    { label: "Property star rating", key: "propertyStarRating" },
    { label: "Adults", key: "adults" },
    { label: "Children", key: "children" },
    { label: "Cancellation Policy", key: "cancellationPolicy" },
    { label: "Refund Amount(USD)", key: "RefundAmountIfAny" },
  ];

  useEffect(() => {
    getArrivalList(0, "");
    handleDownloadProcess();
  }, []);

  const getArrivalList = (page, search) => {
    let data = {
      page: page,
      searchChar: search,
    };
    Axios.post(process.env.REACT_APP_BACKEND + "get-all-arrival", data)
      .then((resp) => {
        setArrivalList(resp?.data?.data?.data);
        setCount(resp?.data?.data?.totalCount);
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };
  const handleDialogOpen = (id) => {
    setOpenDialog({ status: true, id: id?.internalRoomBookingId });
  };

  const handleDialogClose = () => {
    setOpenDialog({ status: false, id: "" });
  };

  const handleDownloadProcess = () => {
    Axios.post(process.env.REACT_APP_BACKEND + "get-all-csv-data")
      .then((resp) => {
        setDownloadData(resp?.data?.data);
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };

  const options = {
    responsive: "standard",
    selectableRows: "none",
    filter: false,
    viewColumns: false,
    rowsPerPageOptions: [],
    serverSide: true,
    count: count,
    page,
    download: false,
    onTableChange: (action, tableState) => {
      if (action === "changePage") {
        getArrivalList(tableState.page, search);
        setPage(tableState.page);
      }
    },
    onSearchChange: (searchText) => {
      getArrivalList(page, searchText);
      setSearch(searchText);
    },
    customToolbar: () => (
      <>
        <Tooltip title="Download">
          <IconButton>
            <CSVLink
              data={downloadData}
              headers={headers}
              filename={"bookingList.csv"}
            >
              <DownloadIcon className="downLoadCSVIcon" />
            </CSVLink>
          </IconButton>
        </Tooltip>
      </>
    ),
  };

  const columns = [
    {
      name: "bookingId",
      label: "Booking Id",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          const bookingID = arrivalList[dataIndex]?.sevenlyBookingId;

          return <p>{bookingID}</p>;
        },
      },
    },
    {
      name: "providerId",
      label: "Provider Id",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          const bookingID = arrivalList[dataIndex]?.providerId;

          return <p>{bookingID}</p>;
        },
      },
    },
    {
      name: "channelId",
      label: "Channel Id",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          const bookingID = arrivalList[dataIndex]?.channelId;

          return <p>{bookingID}</p>;
        },
      },
    },
    {
      name: "bookingRefIds",
      label: "ZH Id",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          const bookingID = arrivalList[dataIndex]?.bookingRefIds;
          return (
            <div>
              {bookingID && bookingID.length !== 0
                ? bookingID.map((item, i) => <p key={i}>{item}</p>)
                : bookingID}
            </div>
          );
        },
      },
    },
    {
      name: "creationDate",
      label: "Booking Date",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <div>
              {arrivalList[dataIndex].creationDate &&
                `${
                  arrivalList[dataIndex].creationDate.split("T")[0]
                } ${arrivalList[dataIndex].creationDate
                  .split("T")[1]
                  .split(":")
                  .slice(0, 2)
                  .join(":")}`}
            </div>
          );
        },
      },
    },
    {
      name: "customerEmail",
      label: "Customer email",
      options: {
        filter: false,
        sort: false,

        customBodyRenderLite: (dataIndex) => {
          const email = arrivalList[dataIndex]?.billingContact?.contact?.email;

          return <p>{email}</p>;
        },
      },
    },

    {
      name: "sellRate",
      label: "Sell Rate(USD)",
      options: {
        filter: false,
        sort: false,

        customBodyRenderLite: (dataIndex) => {
          const sellRate = arrivalList[dataIndex]?.totalAmount;
          return <p>{sellRate}</p>;
        },
      },
    },

    {
      name: "status",
      label: "Status",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          const bookingStatus =
            arrivalList[dataIndex]?.bookingStatus === "Confirmed";
          return (
            <span
              className="capsule"
              style={{
                backgroundColor: bookingStatus ? "#d4f8e8" : "#f8d7da",
                color: bookingStatus ? "#28a745" : "#dc3545",
              }}
            >
              {arrivalList[dataIndex]?.bookingStatus}
            </span>
          );
        },
      },
    },
    {
      name: "options",
      label: "Action",

      options: {
        filter: false,
        sort: false,

        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              <Tooltip title="Booking List">
                <IconButton
                  aria-label="Booking List"
                  onClick={() => handleOpen(arrivalList[dataIndex], "view")}
                >
                  <RemoveRedEyeOutlinedIcon className="icon-size" />
                </IconButton>
              </Tooltip>
            </>
          );
        },
      },
    },
  ];
  const handleOpen = (data) => {
    setViewData(data);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setViewData(null);
  };
  const bookingCancel = () => {
    const api = "cancel-booking";
    const data = {
      bId: openDialog.id,
      remarks: remarks,
    };

    Axios.post(process.env.REACT_APP_BACKEND + api, data)
      .then((resp) => {
        setOpenDialog({ status: false, id: "" });
        setOpen(false);
        setRemarks(resp?.data?.data?.cancelationRemarks);
        toast.success(
          resp?.data?.message || "Booking status updated successfully"
        );
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message || "Failed to update booking status"
        );
      });
  };
  return (
    <>
      <Helmet>
        <title>Sevenly-Booking</title>
        <meta name="FAQ" content="FAQ for Home Page" />
      </Helmet>
      <h1 className="mb--12 sevenly-cursor"> — </h1>
      <div className="d-flex justify-content-between mb-2">
        <h2>Booking Management</h2>
      </div>

      <MUIDataTable
        title={"Booking List Management"}
        data={arrivalList}
        columns={columns}
        options={options}
      />
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        open={open}
        maxWidth="xl"
      >
        <div className="d-flex justify-content-between align-center p-3">
          <h3>View Booking</h3>
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </div>
        <DialogContent dividers>
          <>
            <div className="viewDetials">
              <div className="row">
                <div className="col-md-12">
                  <div className="d-flex justify-content-between mb-3">
                    <p className="fs-16 fw-600 mb-3">
                      Booking ID :
                      <span className="fw-500 fs-18 ms-1">
                        {" "}
                        {viewData?.bookingId}
                      </span>
                    </p>
                    <p className="fs-16 fw-600 mb-3">
                      Booking Date :
                      <span className="fw-500 fs-18 ms-1">
                        {viewData?.creationDate &&
                          `${
                            viewData.creationDate.split("T")[0]
                          } ${viewData.creationDate
                            .split("T")[1]
                            .split(":")
                            .slice(0, 2)
                            .join(":")}`}
                      </span>
                    </p>
                  </div>
                  <p className="fs-16 fw-600 mb-3">
                    Total Amount :
                    <span className="fw-500 fs-18 ms-1">
                      $ {viewData?.totalAmount}
                    </span>
                  </p>

                  {viewData?.tripHotels.map((item, index) => (
                    <div key={index} className="mt-4">
                      <div
                        className="fs-16 fw-600 mb-3"
                        style={{
                          textAlign: "center",
                          backgroundColor:
                            item?.status.toLowerCase() === "booked"
                              ? "#28a745"
                              : "#dc3545",
                          color: "#fff",
                          padding: "10px",
                          borderRadius: "10px",
                        }}
                      >
                        Hotel Name:
                        <span className="fw-500 fs-18 ms-2">
                          {item?.hotels?.name}
                        </span>
                      </div>
                      <div>
                        <p className="fs-16 fw-600 mb-3">
                          Hotel Confirmation :
                          <span className="fw-500 fs-18 ms-1">
                            {item?.internalRoomBookingId}
                          </span>
                        </p>
                        <p className="fs-16 fw-600 mb-3">
                          Hotel Contact Number :
                          <span className="fw-500 fs-18">
                            {" "}
                            {item?.hotels?.contact?.phones.map((phone, i) => (
                              <span className="fs-14 fw-400" key={i}>
                                {phone}
                              </span>
                            ))}
                          </span>
                        </p>
                        <p className="fs-16 fw-600 mb-3">
                          Hotel Address:
                          <span className="fw-400 ms-2 fs-14">
                            {" "}
                            {item?.hotels?.contact?.address?.line1} -
                            {item?.hotels?.contact?.address?.postalCode}
                          </span>
                        </p>
                        {item?.hotels?.contact?.emails.length !== 0 && (
                          <p className="fs-16 fw-600 mb-3">
                            Hotel Email:
                            <span className="fw-500 fs-18">
                              {" "}
                              {item?.hotels?.contact?.emails.map((email, i) => (
                                <span key={i}>{email}</span>
                              ))}
                            </span>
                          </p>
                        )}
                        <div
                          className="d-flex align-items-center f-wrap"
                          style={{ gap: "50px" }}
                        >
                          <p className="fs-16 fw-600 mb-3">
                            Check IN:{" "}
                            <span className="fw-400 fs-14 ms-2">
                              {item?.checkIn && item.checkIn.split("T")[0]}{" "}
                              {item?.checkIn &&
                                item.checkIn
                                  .split("T")[1]
                                  .split(":")
                                  .slice(0, 2)
                                  .join(":")}
                            </span>
                          </p>
                          <p className="fs-16 fw-600 mb-3">
                            Check out :{" "}
                            <span className="fw-400 fs-14 ms-2">
                              {item?.checkOut && item.checkOut.split("T")[0]}{" "}
                              {item?.checkOut &&
                                item.checkOut
                                  .split("T")[1]
                                  .split(":")
                                  .slice(0, 2)
                                  .join(":")}
                            </span>
                          </p>
                        </div>
                        <p className="fs-16 fw-600 mb-3">
                          Room Type :
                          <span className="fs-16 fw-400 ms-2">
                            {item?.roomsAndRates?.name}
                          </span>
                        </p>
                        <p className="fs-16 fw-600 mb-3">
                          Total Rooms : {item?.reqOccupancies?.rooms}{" "}
                        </p>
                        <p className="fs-16 fw-600 mb-3">
                          Refundability:
                          <span
                            className="fw-500 ms-2"
                            style={{
                              color:
                                item?.roomsAndRates?.refundability ===
                                "Refundable"
                                  ? "#28a745"
                                  : "#dc3545",
                            }}
                          >
                            {item?.roomsAndRates?.refundability}{" "}
                          </span>
                        </p>
                        <div
                          className="d-flex align-items-center f-wrap"
                          style={{ gap: "50px" }}
                        >
                          <p className="fs-16 fw-600 mb-3">Occupancy : </p>
                          <p className="fs-14  mb-3">
                            Adults: {item?.reqOccupancies?.adults}
                          </p>
                          {item?.reqOccupancies?.children &&
                            item?.reqOccupancies?.children.length !== 0 && (
                              <p className="fs-14  mb-3">
                                Childrens :{" "}
                                {item?.reqOccupancies?.children.length}
                              </p>
                            )}
                        </div>
                        <div>
                          {item?.roomsAllocations?.map((room, i) => (
                            <div
                              key={i}
                              className="mb-3 d-flex align-items-center f-wrap"
                              style={{ gap: "50px" }}
                            >
                              {" "}
                              <p className="fs-16 fw-600 mb-3">
                                Room {i + 1} Guests:
                              </p>
                              {room?.guests?.map((guest, j) => (
                                <div>
                                  <p key={j} className="fs-12 mb-3">
                                    Name : {guest?.firstName} {guest?.lastName}
                                  </p>

                                  <p className="fs-12 mb-3">
                                    Email : {guest?.email}
                                  </p>
                                </div>
                              ))}
                            </div>
                          ))}
                        </div>
                        {item?.roomsAndRates &&
                          item?.roomsAndRates?.cancellationPolicies &&
                          item?.roomsAndRates?.cancellationPolicies[0]?.rules &&
                          item?.roomsAndRates.cancellationPolicies[0]?.rules
                            .length !== 0 &&
                          item?.roomsAndRates?.refundability.toLowerCase() ===
                            "refundable" && (
                            <div>
                              <p className="fs-16 fw-600">
                                Cancellation Policy
                              </p>

                              <p className="fs-12">
                                •{" "}
                                {item?.roomsAndRates.cancellationPolicies[0]
                                  ?.rules[0].value === 0
                                  ? "No cancellation fee "
                                  : ` A cancellation fee of  ${
                                      item?.roomsAndRates
                                        .cancellationPolicies[0]?.rules[0]
                                        .valueType === "Percentage"
                                        ? `${item?.roomsAndRates?.cancellationPolicies[0]?.rules[0].value}% of the total amount`
                                        : `$${item?.roomsAndRates?.cancellationPolicies[0]?.rules[0].value.toFixed(
                                            2
                                          )}`
                                    }`}{" "}
                                will be charged if you cancel between{" "}
                                {
                                  item?.roomsAndRates.cancellationPolicies[0]?.rules[0].start.split(
                                    "T"
                                  )[0]
                                }{" "}
                                {item?.roomsAndRates?.cancellationPolicies[0]?.rules[0].start
                                  .split("T")[1]
                                  .split(":")
                                  .slice(0, 2)
                                  .join(":")}{" "}
                                and{" "}
                                {
                                  item?.roomsAndRates.cancellationPolicies[0]?.rules[0].end.split(
                                    "T"
                                  )[0]
                                }{" "}
                                {item?.roomsAndRates?.cancellationPolicies[0]?.rules[0].end
                                  .split("T")[1]
                                  .split(":")
                                  .slice(0, 2)
                                  .join(":")}
                              </p>
                              <p className="fs-12">
                                •{" "}
                                {item?.roomsAndRates?.cancellationPolicies[0]
                                  ?.rules[
                                  item?.roomsAndRates.cancellationPolicies[0]
                                    ?.rules.length - 1
                                ].value === 0
                                  ? "No cancellation fee "
                                  : ` 100% cancellation fee of  `}{" "}
                                will be charged if you cancel after{" "}
                                {
                                  item?.roomsAndRates?.cancellationPolicies[0]?.rules[0].end.split(
                                    "T"
                                  )[0]
                                }{" "}
                                {item?.roomsAndRates?.cancellationPolicies[0]?.rules[0].end
                                  .split("T")[1]
                                  .split(":")
                                  .slice(0, 2)
                                  .join(":")}
                              </p>
                            </div>
                          )}
                        <p
                          className="fs-16 fw-600 mb-3"
                          style={{
                            color:
                              item?.status.toLowerCase() === "booked"
                                ? "#28a745"
                                : "#dc3545",
                          }}
                        >
                          Booking status: {item?.status}{" "}
                        </p>

                        {item?.taxresult?.tax_breakdown[0]?.amount !== 0 && (
                          <>
                            <p className="fs-16 fw-600 mb-4">
                              Taxes :
                              <span className="fw-400 fs-18">
                                {" "}
                                ${" "}
                                {item?.taxresult?.tax_breakdown[0]?.amount /
                                  100}
                              </span>
                            </p>
                            <p className="fs-16 fw-600 mb-4">
                              SubTotal:
                              <span className="fw-400 fs-18">
                                {" "}
                                ${" "}
                                {item?.taxresult?.tax_breakdown[0]
                                  ?.taxable_amount / 100}
                              </span>
                            </p>
                          </>
                        )}
                        <p className="fs-16 fw-600 mb-3">
                          Total Amount : $
                          {parseFloat(item?.taxresult?.amount_total) / 100}
                        </p>
                        {item?.refund && (
                          <div>
                            <p className="fs-16 fw-600 mb-3">
                              Refunded Amount :
                              <span className="fw-500 fs-18">
                                $ {parseFloat(item?.refund?.amount) / 100}
                              </span>
                            </p>
                            <p
                              className="fs-16 fw-600 mb-3"
                              style={{
                                color:
                                  item?.refund?.status.toLowerCase() ===
                                  "succeeded"
                                    ? "#28a745"
                                    : "#dc3545",
                              }}
                            >
                              Refunde Status :
                              <span className="fw-500 fs-18 ms-2">
                                {item?.refund?.status}
                              </span>
                            </p>
                          </div>
                        )}
                        {item?.status.toLowerCase() === "booked" && (
                          <div>
                            <TextField
                              label="Remarks"
                              multiline
                              rows={4}
                              value={remarks}
                              onChange={(e) => setRemarks(e.target.value)}
                              fullWidth
                              margin="normal"
                            />
                            <div
                              style={{
                                display: "flex",
                                gap: "10px",
                                justifyContent: "flex-end",
                              }}
                            >
                              <Button
                                variant="contained"
                                className="cancel-button"
                                onClick={() => handleDialogOpen(item)}
                              >
                                Cancel Booking
                              </Button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}

                  <Dialog open={openDialog.status} onClose={handleDialogClose}>
                    <DialogTitle>
                      Are you sure you want to cancel the booking?
                    </DialogTitle>
                    <DialogContent>
                      <p>Remarks: {remarks}</p>
                    </DialogContent>
                    <DialogActions>
                      <Button
                        className="cancel-button"
                        onClick={handleDialogClose}
                      >
                        No
                      </Button>
                      <Button className="submit-button" onClick={bookingCancel}>
                        Yes
                      </Button>
                    </DialogActions>
                  </Dialog>
                </div>
              </div>
            </div>
          </>
        </DialogContent>
        <DialogActions>
          <Button className="cancel-button" onClick={handleClose}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default BookingList;
